import styled from 'styled-components';
import { layout } from 'src/components/base';

export const ArticleListWrapper = styled.section`
  margin: 0 ${layout.pageContent.gutter.rem};
`;

export const PaginationWrapper = styled.div`
  padding: ${layout.measurements.spacing100} ${layout.measurements.spacing050};
`;

export const BreadCrumbWrapper = styled.div`
  display: flex;
  margin: ${layout.measurements.spacing050} 0 ${layout.measurements.spacing050}
    ${layout.measurements.spacing050};
`;
